
			(async () => {
				console.log("✓ Starting Cortex Root Config UI...");
				await import("./src/main.tsx");
			})();
		